export class Pricesheet {
  id: number;
  contract_id: number;
  base_price: number;
  is_active: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.contract_id = data.contract_id;
    this.base_price = Number(data.base_price ?? 0);
    this.is_active = data.is_active ?? true;
  }
}
